
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'ConsentAdvertising',
  props: {
    advertisingActive: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: true
    }
  },
  emits: ['toggleAdvertisingActive', 'toggleConsentMailing']
})
